import {
  Directive,
  effect,
  inject,
  Input,
  TemplateRef,
  ViewContainerRef,
} from '@angular/core';
import { AuthStore } from '../stores/auth.store';

@Directive({
  selector: '[appHasRole]',
  standalone: true,
})
export class HasRoleDirective {
  private authStore = inject(AuthStore);
  private viewContainerRef = inject(ViewContainerRef);
  private templateRef = inject(TemplateRef);

  private expectedRoles: string[] = [];

  @Input() set appHasRole(roles: string[]) {
    this.expectedRoles = roles ?? [];
    this.evaluateVisibility();
  }

  constructor() {
    effect(() => {
      this.evaluateVisibility();
    });
  }

  private evaluateVisibility() {
    const user = this.authStore.currentUser();

    if (!user?.roles?.length || !this.expectedRoles.length) {
      this.viewContainerRef.clear();
      return;
    }

    const userRoles = new Set(user.roles.map((r) => r.roleCode));

    const hasRole = this.expectedRoles.some((role) => userRoles.has(role));

    if (hasRole) {
      if (this.viewContainerRef.length === 0) {
        this.viewContainerRef.createEmbeddedView(this.templateRef);
      }
    } else {
      this.viewContainerRef.clear();
    }
  }
}
